import { Tab } from "bootstrap";

document.addEventListener("DOMContentLoaded", function () {
  // Allow Page URL to activate a tab's ID
  var taburl = document.location.toString();
  if (taburl.match("#")) {
    var targetTab = document.querySelector(
      '.nav-tabs a[href="#' + taburl.split("#")[1] + '"]'
    );

    if (targetTab) {
      var tabTrigger = new Tab(targetTab);
      tabTrigger.show();
    }
  }

  // Allow internal links to activate a tab.
  var tabLinks = document.querySelectorAll('a[data-toggle="tab"]');
  tabLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var targetTab = document.querySelector(
        'a[href="' + link.getAttribute("href") + '"]'
      );
      if (targetTab) {
        var tabTrigger = new Tab(targetTab);
        tabTrigger.show();
      }
    });
  });
});

// # $ ->
// #   # Allow Page URL to activate a tab's ID
// #   taburl = document.location.toString()
// #   if taburl.match('#')
// #     $('.nav-tabs a[href="#' + taburl.split('#')[1] + '"]').tab 'show'
// #   # Allow internal links to activate a tab.
// #   $('a[data-toggle="tab"]').click (e) ->
// #     e.preventDefault()
// #     $('a[href="' + $(this).attr('href') + '"]').tab 'show'
